var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AIInfoModal',{attrs:{"current-copy":_vm.currentCopy,"total-panel-count":_vm.totalPanelCount,"current-progress":_vm.currentProgress},on:{"primary":_vm.handlePrimary,"secondary":_vm.handleSecondary,"close":_vm.closeGuidanceInfoModal}})}
var staticRenderFns = []

export { render, staticRenderFns }